import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { FaUserPlus } from 'react-icons/fa';
import UserStatsCards from '../../../components/admin/AdminUsersManagement/UserStatsCards';
import UserTables from '../../../components/admin/AdminUsersManagement/UserTables';
import AddAdminModal from '../../../components/admin/AdminUserManagement/AddAdminModal';
import '../../../assets/css/admin/adminUserManagement/adminusermanagement.css';

const AdminUserManagement = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('customers');
  const [stats, setStats] = useState({ totaladmins: 0, total: 0, active: 0, inactive: 0, pending: 0, blocked: 0 });
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [showAddAdmin, setShowAddAdmin] = useState(false);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/users/admins')) setActiveTab('admins');
    else if (path.includes('/users/vendors')) setActiveTab('vendors');
    else setActiveTab('customers');
    setSearchTerm('');
    setStatusFilter('all');
  }, [location.pathname]);

  const handleFilterChange = (field, value) => {
    if (field === 'search') setSearchTerm(value);
    if (field === 'status') setStatusFilter(value);
  };

  const pageMeta = {
    admins: { title: 'Admin Management', subtitle: 'Manage admin users and permissions' },
    vendors: { title: 'Vendor Directory', subtitle: 'Manage and monitor all registered vendors' },
    customers: { title: 'Customer Management', subtitle: 'Manage all customer accounts' },
  };
  const { title, subtitle } = pageMeta[activeTab];

  return (
    <div className="adm-user-management-container">
      <Container fluid>
        <div className="adm-user-management-header">
          <div>
            <h1 className="adm-user-page-title">{title}</h1>
            <p className="adm-user-page-subtitle">{subtitle}</p>
          </div>
          <div className="adm-user-header-actions">
            {activeTab === 'admins' && (
              <button className="adm-user-btn-add" onClick={() => setShowAddAdmin(true)}>
                <FaUserPlus /> Add New Admin
              </button>
            )}
          </div>
        </div>

        <UserStatsCards role={activeTab} stats={stats} />
       
        <UserTables role={activeTab} searchTerm={searchTerm} statusFilter={statusFilter} onStatsUpdate={setStats} />
      </Container>

      {showAddAdmin && <AddAdminModal onClose={() => setShowAddAdmin(false)} onSuccess={() => setShowAddAdmin(false)} />}
    </div>
  );
};

export default AdminUserManagement;